const marketingOrderConstants = {
  SET_CALLBACK_FUNC: 'MARKETING_ORDER.SET_CALLBACK_FUNC',
  SET_THUOC_INFO: 'MARKETING_ORDER.SET_THUOC_INFO',
  SET_MODE_FORM: 'MARKETING_ORDER.SET_MODE_FORM',
  SET_FLAG_ADD_ITEM: 'MARKETING_ORDER.SET_FLAG_ADD_ITEM',
  SET_WARNING_ITEM: 'MARKETING_ORDER.SET_WARNING_ITEM',
  SET_ERROR: 'MARKETING_ORDER.SET_ERROR',
  SET_IS_LOADING: 'MARKETING_ORDER.SET_IS_LOADING',
  SET_MESSAGE: 'MARKETING_ORDER.SET_MESSAGE',
  SET_TYPEOF_ORDER: 'MARKETING_ORDER.SET_TYPEOF_ORDER',
  SET_ORDER_ID: 'MARKETING_ORDER.SET_ORDER_ID',
  SET_USERS: 'MARKETING_ORDER.SET_USERS',
  SET_ITEM: 'MARKETING_ORDER.SET_ITEM',
  SET_ITEMS: 'MARKETING_ORDER.SET_ITEMS',
  SET_ORDER_INFOR: 'MARKETING_ORDER.SET_ORDER_INFOR',
  SET_USERS_CHECKED: 'MARKETING_ORDER.SET_USERS_CHECKED',
  SET_CUSTOMERS: 'MARKETING_ORDER.SET_CUSTOMERS',
  SET_CUSTOMER_INFO: 'MARKETING_ORDER.SET_CUSTOMER_INFO',
  SET_THUOCS: 'MARKETING_ORDER.SET_THUOCS',
  SET_KHOS: 'MARKETING_ORDER.SET_KHOS',
  SET_ORDER_HISTORY: 'MARKETING_ORDER.SET_ORDER_HISTORY',
  SET_ORDER_EXPORT: 'MARKETING_ORDER.SET_ORDER_EXPORT',
  UNLOCK_ORDER: 'MARKETING_ORDER.UNLOCK_ORDER',
  LOAD_USERS: 'MARKETING_ORDER.LOAD_USERS',
  LOAD_CUSTOMERS: 'MARKETING_ORDER.LOAD_CUSTOMERS',
  LOAD_CUSTOMER_INFO: 'MARKETING_ORDER.LOAD_CUSTOMER_INFO',
  LOAD_THUOCS: 'MARKETING_ORDER.LOAD_THUOCS',
  LOAD_KHOS: 'MARKETING_ORDER.LOAD_KHOS',
  LOAD_THUOC_INFO: 'MARKETING_ORDER.LOAD_THUOC_INFO',
  LOAD_ORDER_HISTORY: 'MARKETING_ORDER.LOAD_ORDER_HISTORY',
  LOAD_ORDER_EXPORT: 'MARKETING_ORDER.LOAD_ORDER_EXPORT',
  LOAD_ORDER_EXCEL: 'MARKETING_ORDER.LOAD_ORDER_EXCEL',
  CAN_PUSH_ORDER: 'MARKETING_ORDER.CAN_PUSH_ORDER',
  RESET_FORM: 'MARKETING_ORDER.RESET_FORM',
  SAVE_ORDER: 'MARKETING_ORDER.SAVE_ORDER',
  CANCEL_ORDER: 'MARKETING_ORDER.CANCEL_ORDER',
  SEND_ORDER: 'MARKETING_ORDER.SEND_ORDER',
  LOAD_ORDER_DETAILS: 'MARKETING_ORDER.LOAD_ORDER_DETAILS',
  LOAD_KHOS_API: '/api/v1/kho/get_kho_of_user',
  LOAD_USERS_API: '/api/v1/users/get_list_by_quanly',
  LOAD_THUOCS_API: '/api/v1/export/list_thuoc_for_export_by',
  CAN_PUSH_ORDER_API: '/api/v1/export/can_push_order',
  LOAD_CUSTOMER_INFO_API: '/api/v1/export/customer_details',
  SAVE_ORDER_API: '/api/v2/export/marketing_save_order',
  SEND_ORDER_API: '/api/v2/export/marketing_send_order',
  CANCEL_ORDER_API: '/api/v2/export/marketing_cancel_order',
  UNLOCK_ORDER_API: '/api/v2/export/marketing_unlock_order',
  LOAD_ORDER_HISTORY_API: '/api/v2/export/marketing_lich_su_by',
  LOAD_CUSTOMERS_API: '/api/v2/export/marketing_get_customers_for_order',
  LOAD_THUOC_INFO_API: '/api/v2/export/marketing_update_thuoc_for_order',
  LOAD_ORDER_DETAILS_API: '/api/v2/export/marketing_order_details',
  MODE: {
    IN_CREATE: 'IN_CREATE',
    IN_EDIT: 'IN_EDIT',
    IN_VIEW: 'IN_VIEW'
  }
}

export default marketingOrderConstants;


// WEBPACK FOOTER //
// ./src/views/MarketingOrder/constants.js